var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClientSide(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "73px",
    height: "51px",
    viewBox: "0 0 73 51",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 18") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-18"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#C7C7C7",
    x: 0,
    y: 0,
    width: 73,
    height: 51
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-24",
    transform: "translate(16.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#979797",
    fill: "#D8D8D8",
    x: 1.5,
    y: 27.5,
    width: 37,
    height: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-23"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#615C5C",
    strokeWidth: 1.5,
    fill: "#282727",
    x: 3.68689272,
    y: 0.75,
    width: 32.6147132,
    height: 19.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-22",
    transform: "translate(9.136681, 5.109131)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-20",
    transform: "translate(0.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E15252",
    x: 4.10885313,
    y: 2.87504481,
    width: 2.80214704,
    height: 1.47229926,
    rx: 0.585
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#69A4FF",
    x: 9.24223084,
    y: 4.52770074,
    width: 2.80214704,
    height: 1.47229926,
    rx: 0.585
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#78A045",
    x: 14.3756086,
    y: 2.87504481,
    width: 2.80214704,
    height: 1.47229926,
    rx: 0.585
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.772962683,0.76291555 L2.46916972,0.810711138 C2.77941079,0.819453086 3.02882698,1.06895242 3.03746553,1.37919638 L3.04494037,1.64764691 C3.05393303,1.97060831 2.79941107,2.23971025 2.47644967,2.24870291 C2.46553169,2.24900691 2.45460735,2.24900509 2.44368947,2.24869745 L0.747482434,2.20090186 C0.437241365,2.19215991 0.187825174,1.94266058 0.179186624,1.63241662 L0.171711786,1.3639661 C0.162719126,1.04100469 0.417241083,0.77190275 0.740202489,0.762910091 C0.751120463,0.762606087 0.762044811,0.762607907 0.772962683,0.76291555 Z",
    id: "Rectangle",
    fill: "#1EAD63",
    transform: "translate(1.608326, 1.505807) rotate(39.000000) translate(-1.608326, -1.505807) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7203253,0.76291555 L20.4165324,0.810711138 C20.7267734,0.819453086 20.9761896,1.06895242 20.9848282,1.37919638 L20.992303,1.64764691 C21.0012957,1.97060831 20.7467737,2.23971025 20.4238123,2.24870291 C20.4128943,2.24900691 20.40197,2.24900509 20.3910521,2.24869745 L18.6948451,2.20090186 C18.384604,2.19215991 18.1351878,1.94266058 18.1265493,1.63241662 L18.1190744,1.3639661 C18.1100818,1.04100469 18.3646037,0.77190275 18.6875651,0.762910091 C18.6984831,0.762606087 18.7094074,0.762607907 18.7203253,0.76291555 Z",
    id: "Rectangle",
    fill: "#69FFB6",
    transform: "translate(19.555689, 1.505807) scale(1, -1) rotate(39.000000) translate(-19.555689, -1.505807) "
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#B6FF00",
    cx: 16.0820074,
    cy: 1,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#CAD5AE",
    cx: 5.0820074,
    cy: 1,
    r: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-21",
    transform: "translate(7.082007, 2.000000)",
    fill: "#E152C5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.39712649,1.72614641 L2.24896093,0.868267672 C2.44520437,0.670631767 2.76450666,0.669502948 2.96214256,0.865746383 C3.05748913,0.960421176 3.11111111,1.08923161 3.11111111,1.22359784 L3.11111111,2.41500002 C3.11111111,2.73808659 2.8491977,3 2.52611113,3 L0.938028118,3 C0.73742271,3 0.574799896,2.83737719 0.574799896,2.63677178 C0.574799896,2.53457011 0.617856273,2.43709727 0.693405375,2.36826767 L1.37598826,1.74639526 C1.38320212,1.73982301 1.39025041,1.73307128 1.39712649,1.72614641 Z",
    id: "Rectangle"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.28601537,1.72614641 L6.13784982,0.868267672 C6.33409325,0.670631767 6.65339555,0.669502948 6.85103145,0.865746383 C6.94637802,0.960421176 7,1.08923161 7,1.22359784 L7,2.41500002 C7,2.73808659 6.73808659,3 6.41500002,3 L4.82691701,3 C4.6263116,3 4.46368878,2.83737719 4.46368878,2.63677178 C4.46368878,2.53457011 4.50674516,2.43709727 4.58229426,2.36826767 L5.26487715,1.74639526 C5.27209101,1.73982301 5.27913929,1.73307128 5.28601537,1.72614641 Z",
    id: "Rectangle",
    transform: "translate(5.444444, 1.500000) scale(-1, 1) translate(-5.444444, -1.500000) "
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M36.4233385,21.7228285 L38.5973245,26.8335145 L1.42796141,26.8335145 L3.5689126,21.7228285 L36.4233385,21.7228285 Z",
    id: "Rectangle",
    stroke: "#050505",
    strokeWidth: 1.9,
    fill: "#616161"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-2",
    transform: "translate(15.000000, 25.000000)",
    fill: "#616161"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 11,
    height: 2
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientSide);
export default __webpack_public_path__ + "static/media/clientSide.e7232d5b8be2762a9a045a085a6dd578.svg";
export { ForwardRef as ReactComponent };